module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Sawnoff_C.37598de1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Handgun/Item_Weapon_Sawnoff_C.png
// module id = 207
// module chunks = 0